import { ArrowLeftLineIcon, IconButton } from "@relex-solutions/fragments"
import styles from "./CustomerPageHeading.module.css"

interface CustomerPageHeadingProps {
  header?: string
  onBack?: () => void
}

export function CustomerPageHeading({ header = " ", onBack }: CustomerPageHeadingProps) {
  return (
    <div className={styles.container}>
      {onBack && (
        <IconButton aria-label="Back to customer list" variant="ghost" className={styles.backButton} onClick={onBack}>
          <ArrowLeftLineIcon />
        </IconButton>
      )}
      <h1 className={`${styles.header} fr-text-500`}>{header}</h1>
    </div>
  )
}
